var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 22.75H8C4.35 22.75 2.25 20.65 2.25 17V7C2.25 3.35 4.35 1.25 8 1.25H16C19.65 1.25 21.75 3.35 21.75 7V17C21.75 20.65 19.65 22.75 16 22.75ZM8 2.75C5.14 2.75 3.75 4.14 3.75 7V17C3.75 19.86 5.14 21.25 8 21.25H16C18.86 21.25 20.25 19.86 20.25 17V7C20.25 4.14 18.86 2.75 16 2.75H8Z",
    fill: "#3E485B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 9.25H16.5C14.98 9.25 13.75 8.02 13.75 6.5V4.5C13.75 4.09 14.09 3.75 14.5 3.75C14.91 3.75 15.25 4.09 15.25 4.5V6.5C15.25 7.19 15.81 7.75 16.5 7.75H18.5C18.91 7.75 19.25 8.09 19.25 8.5C19.25 8.91 18.91 9.25 18.5 9.25Z",
    fill: "#3E485B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99945 17.75C9.80945 17.75 9.61945 17.68 9.46945 17.53L7.46945 15.53C7.17945 15.24 7.17945 14.7599 7.46945 14.4699L9.46945 12.4699C9.75945 12.1799 10.2395 12.1799 10.5295 12.4699C10.8195 12.7599 10.8195 13.24 10.5295 13.53L9.05945 15L10.5295 16.4699C10.8195 16.7599 10.8195 17.24 10.5295 17.53C10.3795 17.68 10.1895 17.75 9.99945 17.75Z",
    fill: "#3E485B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9995 17.75C13.8095 17.75 13.6195 17.68 13.4695 17.53C13.1795 17.24 13.1795 16.7599 13.4695 16.4699L14.9395 15L13.4695 13.53C13.1795 13.24 13.1795 12.7599 13.4695 12.4699C13.7595 12.1799 14.2395 12.1799 14.5295 12.4699L16.5295 14.4699C16.8195 14.7599 16.8195 15.24 16.5295 15.53L14.5295 17.53C14.3795 17.68 14.1895 17.75 13.9995 17.75Z",
    fill: "#3E485B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentCode);
export default __webpack_public_path__ + "static/media/document-code.c019fe191cd71a16ed0db706fce9e07f.svg";
export { ForwardRef as ReactComponent };